import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import NewsletterForm from '@components/shared/NewsletterForm';
import { P } from '@components/shared/Typography';
import { useCountry } from '@hooks/useCountry';
import { getKlaviyoTrackingListId } from '@utils/helpers';

const FooterRegister: React.FC = () => {
  const { country } = useCountry();
  const { t } = useTranslation();

  return (
    <Container>
      <P $mods={['white', 'bold', 16]} $mobileMods={['center']} style={{ marginBottom: 20 }}>
        {t('components.subscribe-now-discount', { discountNum: 15 })}
      </P>
      <NewsletterForm location="footer" listId={getKlaviyoTrackingListId(country)} />
    </Container>
  );
};

export default FooterRegister;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 270px;

  input {
    border: none;
  }

  input + button {
    margin-left: 10px;
  }

  @media only screen and (max-width: 1024px) {
    max-width: none;
    width: 100%;
  }
`;
